export const dataHooks = {
  button: 'fill-preview-button',
};
